import { useState } from "react";
import { NavLink } from "react-router-dom";
import { LuPanelLeftClose, LuPanelRightClose } from "react-icons/lu";
import { DashboardIcon, CalculatorIcon, OffersIcon, CustomersIcon, ContractsIcon, CalendarIcon, NewsIcon, BundlesIcon, InboxIcon, ReportsIcon, TeamIcon, UserIcon, SecurityIcon, LicenseIcon, SettingsIcon, AdminIcon, AIIcon } from "../../../shared/margincalculator/components/icons/Icon";
import "./MarginCalculatorSideTabs.scss";

function SideTabs() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuGroups = [
    {
      id: "group1",
      items: [
        {
          name: "Dashboard",
          path: "/app/margin-calculator/dashboard",
          icon: <DashboardIcon />,
        },
      ],
    },
    {
      id: "group2",
      title: "Tagesgeschäft",
      items: [
        {
          name: "Margenkalkulator",
          path: "/app/margin-calculator/kalkulator",
          icon: <CalculatorIcon />,
        },
        {
          name: "Angebote",
          path: "/app/margin-calculator/angebote",
          icon: <OffersIcon />,
        },
        {
          name: "Kunden",
          path: "/app/margin-calculator/kunden",
          icon: <CustomersIcon />,
        },
        {
          name: "Verträge",
          path: "/app/margin-calculator/vertraege",
          icon: <ContractsIcon />,
        },
      ],
    },
    {
      id: "group3",
      title: "Werkzeuge",
      items: [
        {
          name: "Kalendar",
          path: "/app/margin-calculator/calendar",
          icon: <CalendarIcon />,
        },
        {
          name: "News&Aktionen",
          path: "/app/margin-calculator/news",
          icon: <NewsIcon />,
        },
        {
          name: "Bundles",
          path: "/app/margin-calculator/bundles",
          icon: <BundlesIcon />,
        },
        {
          name: "Posteingang",
          path: "/app/margin-calculator/inbox",
          icon: <InboxIcon />,
        },
      ],
    },
    {
      id: "group4",
      title: "Auswertungen",
      items: [
        {
          name: "Auswertungen",
          path: "/app/margin-calculator/reports",
          icon: <ReportsIcon />,
        },
        { name: "Teams", path: "/app/margin-calculator/team", icon: <TeamIcon /> },
      ],
    },
    {
      id: "group5",
      title: "Mein Konto",
      items: [
        {
          name: "Meine Daten",
          path: "/app/margin-calculator/my-data",
          icon: <UserIcon />,
        },
        {
          name: "Sicherheit",
          path: "/app/margin-calculator/security",
          icon: <SecurityIcon />,
        },
        {
          name: "Lizenz",
          path: "/app/margin-calculator/license",
          icon: <LicenseIcon />,
        },
      ],
    },
    {
      id: "group6",
      title: "Shop-Verwaltung",
      items: [
        {
          name: "Shop-Einstellungen",
          path: "/app/margin-calculator/shop-settings",
          icon: <SettingsIcon />,
        },
        {
          name: "Mitarbeiter-Rechte",
          path: "/app/margin-calculator/employee-rights",
          icon: <AdminIcon />,
        },
        {
          name: "News verwalten",
          path: "/app/margin-calculator/news-management",
          icon: <NewsIcon />,
        },
        {
          name: "Mengen-Boni",
          path: "/app/margin-calculator/quantity-bonuses",
          icon: <AIIcon />,
        },
      ],
    },
  ];

  return (
    <nav className={`side-tabs ${isCollapsed ? "side-tabs--collapsed" : ""}`}>
      <div className="side-tabs__menu">
        <button
          type="button"
          className="side-tabs__toggle"
          onClick={() => setIsCollapsed((prev) => !prev)}
          title={isCollapsed ? "Ausklappen" : "Einklappen"}
          aria-label={isCollapsed ? "Sidebar ausklappen" : "Sidebar einklappen"}
          aria-expanded={!isCollapsed}
        >
          {isCollapsed ? (
            <LuPanelRightClose className="side-tabs__icon" />
          ) : (
            <LuPanelLeftClose className="side-tabs__icon" />
          )}
          {!isCollapsed && " Einklappen"}
        </button>
        <div className="side-tabs__group-container">
        {menuGroups.map((group) => (
          
          <div
            key={group.id}
            className={`side-tabs__group ${
              group.id === "group4" || group.id === "group5"
                ? "side-tabs__group--border"
                : ""
            }`}
          >
            {group.title && (
              <span className="side-tabs__group-title">{group.title}</span>
            )}
            <div className="side-tabs__items">
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `side-tabs__item ${isActive ? "side-tabs__item--active" : ""}`
                  }
                  title={isCollapsed ? item.name : undefined}
                  aria-label={item.name}
                >
                  <span className="side-tabs__icon">{item.icon}</span>
                  {!isCollapsed && <span className="side-tabs__tooltip">{item.name}</span>}

                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </div></div>
    </nav>
  );
}

export default SideTabs;
